export const COMPETITION_HEADER_AVATAR_SIZE = 28;
export const COMPETITION_HEADER_ICON_SIZE = 22;
export const COMPETITION_HEADER_ICON_SIZE_NARROW = 20;
export const COMPETITION_HEADER_CREST_SIZE = 26;
export const COMPETITION_HEADER_CREST_SIZE_NARROW = 22;
/**
 * Breathing room around the crest: the badge diameter is the crest size plus twice this.
 * It is NOT padding on a wrapper — a padded wrapper insets the scrim's fill box while the
 * zoomed flag draws from outside it, which leaves an unscrimmed rim on the flag badge.
 */
export const COMPETITION_HEADER_CREST_INSET = 3;
/** Below this width the Info button is dropped so the title never truncates. */
export const COMPETITION_HEADER_SHOW_INFO_MIN_WIDTH = 380;

export const COMPETITION_HEADER_COPY = {
  BACK_ACCESSIBILITY: 'Back to tournaments',
  RULES_ACCESSIBILITY: 'How this competition works',
  STANDINGS_ACCESSIBILITY: 'Open standings and bracket',
  MENU_ACCESSIBILITY: 'Open menu',
} as const;

export const COMPETITION_HEADER_TEST_IDS = {
  root: 'competition-screen-header',
  back: 'competition-header-back',
  rules: 'competition-header-rules',
  standings: 'competition-header-standings',
  menu: 'competition-header-menu',
  crest: 'competition-header-crest',
} as const;
